import FarmacieListPage from "./pages/FarmacieListPage.vue";
import FarmacieEditPage from "./pages/FarmacieEditPage.vue";
import FarmacieViewPage from "./pages/FarmacieViewPage.vue";

export default {
  FarmacieListPage,
  FarmacieEditPage,
  FarmacieViewPage,
};